import validate from 'lib/utils/validationRules';
import { events as alert } from '@/plugins/capusta_alert/events';

import HTTPService from '@/services/Http';

const ALERT_TEXT = {
  ['OPENED']: 'safe.deal.opened.title',
  ['CLOSED']: 'safe.deal.closed.title',
  ['CHALLENGE_SUCCESS']: 'safe.deal.challenge.success.title',
};

export default async function dealDisputeResolve({ to, next, store }) {
  const { query } = to;

  if (!validate.isObjectWithFields(query, ['publicId'])) {
    return next({ name: 'cabinet' });
  }

  if (validate.isEmptyString(query.publicId)) {
    return next({ name: 'cabinet' });
  }

  try {
    await store.dispatch('transaction/fetchTransaction', query.publicId);

    const { data } = await HTTPService.dealDisputeResolve({
      ...store.getters['transaction/getDeal'],
      dispute: null,
    });

    store.commit('CHANGE_SELECTED_TRANSACTION_DEAL', data);

    alert.$emit('show', {
      type: 'success',
      text: ALERT_TEXT[data.status],
    });
  } catch (error) {
    console.error(error);

    alert.$emit('show', {
      type: 'warning',
      text: 'error.in.system',
    });
  }

  return next({
    name: 'cabinet',
    query: { public_id: query.publicId },
  });
}
